const localizations = {
  'hi': 'أهلا وسهلا',
  'Thanks for your generous heart. You are changing the world for a lot of people who lost hope': '.شكرا لقلبكم السخي. أنت تغير حياة الكثير من الناس الذين فقدوا الأمل',
  'Login successfully!': '!تسجيل الدخول بنجاح',
  'Loading': 'جاري التحميل',
  'Page is under-construction': 'الصفحة قيد الإنشاء',
  'address': 'عنوان',
  'city': 'المدينة',
  'twitter': 'تويتر',
  'Charities': 'الجمعيات الخيرية',
  'My Donations': 'تبرعاتي',
  'Sign in using Facebook': 'أدخل مستخدما الفيسبوك',
  'Home': 'الرئيسية',
  'Solidarity Account': 'حساب التضامن',
  'Total Donations': 'إجمالي للتبرعات',
  'Country': 'الوطن',
  'Email': 'البريد الالكتروني',
  'Password': 'كلمة السر',
  'Settings': 'إعدادات',
  'Wallet Balance': 'رصيد المحفظة',
  'Account balance': 'رصيد الحساب',
  'Net Amount': 'المبلغ الصافي',
  'Card Number': 'رقم البطاقة',
  'CVV Code': 'رقم الكود',
  'Expiration Date': 'تاريخ الإنتهاء',
  'MM': 'الشهر',
  'YY': 'السنة',
  'Charged Amount': 'المبلغ المشحون',
  'Refill': 'إعادة تعبئة',
  'Old Password': 'كلمة مرور القديمة',
  'New Password': 'كلمة المرور الجدية',
  'Confirm Password': 'تأكد كلمة المرور',
  'Change Password': 'تغيير كلمة السر',
  'Sign up': 'سجل',
  'First name': 'الإسم الأول',
  'Last name': 'الكنية',
  'Birthday': 'تاريخ الولادة',
  'Gender': 'الجنس',
  'Male': 'دكر',
  'Female': 'أنثى',
  'Nationality': 'الجنسية',
  'If you already have an account': 'إذا كان لديك حساب',
  'Login here': 'أدخل هنا',
  'If you don\'t have an account yet': 'إذا لم يكن لديك حساب',
  'Sign up here': 'سجل هنا',
  'Unable to set charities list': 'غير قادر على تعيين قائمة الجمعيات الخيرية',
  'Error while loading charities list': 'حدث خطأ أثناء تحميل قائمة المؤسسات الخيرية',
  'Not data in resp': 'لا توجد بيانات في الرد',
  'Card registration error': 'خطأ في تسجيل البطاقة',
  'Error occured while waiting for the payments service': 'حدث خطأ أثناء انتظار خدمة الدفعات',
  'The card number is too short': 'رقم البطاقة قصير جدا',
  'The expiration date is either invalid or already expired': 'تاريخ انتهاء الصلاحية إما غير صالح أو منتهية الصلاحية',
  'No email, please logout and login again': 'لا البريد الإلكتروني في المخزن، يرجى الخروج وتسجيل الدخول مرة أخرى',
  'Error rechargin account': 'حدث خطأ أثناء إعادة شحن الحساب',
  'Recharge successful': 'نجحت بإعادة',
  'Login': 'الدخول',
  'Logout': 'الخروج',
  'EUR': 'يورو',
  'Donation Destination': 'جهة التبرع',
  'Sorry, your donation to this charity failed': 'عذرا، فشل التبرع لهذا الجمعية الخيرية',
  'donation successful': 'نجحت في التبرع',
  '2 euros are the least amount you can donate': 'أقل كميةيمكن أن تتبرع 20 يورو',
  'Invalid charity id': 'معرف الجمعية غير صحيح',
  'Donate': 'تبرع',
  'ES': 'أسبانيا',
  'FR': 'فرنسا',
  'BE': 'بلجيكا',
  'CH': 'سويسرا',
  'MA': 'المغرب',
  'TN': 'تونس',
  'GB': 'المملكة المتحدة',
  'US': 'الولايات المتحدة',
  'Help': 'مساعدة',
  'Terms and conditions': 'الشروط والأحكام',
  'Login as Establishment': 'أدخل كمؤسسة',
  'Login as User': 'أدخل كمستخدم عادي',
  'Signup as Establishment': 'سجل كمؤسسة',
  'Signup as User': 'سجل كمستخدم',
  'I create and validate my account.<br>I credit my account with my credit card...': 'أسجّل وأفتح حساب أريد أن أساعد للإنخراط٠٠٠أشحن رصيدى بواسطة بطاقة ال ائتمان الخاصّة بى٠٠٠',
  'I can browse non-profit charities and I decide to donate from 2 to 10 euros. I can give as many times as I want...': 'سأجد لائحة الجمعيات المنضمّة وسأقرّرأن أتطوّع بمبلغ يتراوح بين 2 و10 يورو حيث يمكننى التجديد٠٠٠',
  'my donation is transmitted to the charity with 0 comission...': 'تبرّعى أحيل إلى المنضّمة الخيرية بنجاح و بصفة مجّانية٠٠٠',
  'I can ask the charity for my tax certificate.': '',

  'Your subscription ends in {days} day ::: Your subscription ends in {days} days': 'ينتهي إشتراكك في {days} يوم ::: ينتهي إشتراكك في {days} أيام',
  'Duration': 'المدة',
  '1 month': '1 شهر',
  '3 month': '2 شهر',
  '6 month': '6 أشهر',
  '12 month': '12 اشهر',
  'Your QR Code': 'رمز الإستجابة السريع',
  'VAT': 'الضريبة',
  'Total Amount Charged': 'المبلغ الإجمالي المشحونة',
  'Pay Subscription': 'ادفع مبلغ المشاركة',
  'Powered by Mangopay': 'مدعومة من Mangopay',
  'Sorry, only users are allowed to login through this form': 'عذرا، يسمح الدوخو للمستخدمين العاديين فقط',
  'Sorry, only establishments are allowed to login through this form': 'عذرا، يسمح الدخول لمستخدمي المؤسسات فقط ',
  '{x} day ::: {x} days': '{x} يوما ::: {x} أيام',
  'Subscription': 'المشاركة المالية',
  'My QR Code': 'رمز الإستجابة السريع لمؤسستي',
  'TAX': 'الضريبة',
  'Sorry transaction failed': 'معذرة، فشلت  العملية',
  'Subscription successful': 'تم دفع رسوم المشاركة',
  'Started secure transacion please complete process in the new window after you click continue': ' (بدء معاملة آمنة يرجى إكمال العملية في نافذة جديدة بعد النقر (متابعة',
  'Sorry, no 3DS link to complete the transacion': 'عذرا، لايوجد رابط لإتمام العملية في طريقة 3DS',
  'Map': 'الخريطة',
  'Version': 'الإصدار',
  'You are redirected to complete the 3DS secure transacion. If you want the transacion to complete continue to the following page and come back when done': 'تتم إعادة توجيهك لاستكمال المعاملة الآمنة 3DS. إذا كنت تريد إتمام المعاملة، فاستمر في الصفحة التالية وعد هنا عند الانتهاء',
  '3DS Transaction': 'عملية 3DS',
  'Continue': 'متابعة',
  'Skip': 'تخطى',
  'Sorry, no QR code image found': 'عذرا، لايوجد صورة رمز الاستجابة السريع',
  'Days left from subscription': 'الأيام المتبقية من المشاركة',
  'Unable to set associations list': 'تعذر تعيين قائمة الجمعيات',
  'Error while loading associations list': 'حدث خطأ أثناء تحميل قائمة الجمعيات',
  'Country of residence': 'بلد الإقامة',
  'Personal Info': 'المعلومات الشخصية',
  'Establishment Info': 'معلومات الؤسسة',
  'Establishment name': 'اسم المؤسسة',
  'City': 'المدينة',
  'Zip Code': 'رمز البريدي',
  'CIF Code': 'رقم الهوية للضريبة',
  'IWantToHelp': 'IWantToHelp',
  'I have donated to a charity with IWantToHelp http://web.iwanttohelp.org.uk #IWantToHelp': 'تبرعت مستخدما IWantToHelp http://ar.jevaisaider.org/ #JeVaisAider ',
  'fundraising,user,widget,IWantToHelp': 'fundraising,user,widget,JeVaisAider',
  'YQuieroAyudar': 'JeVaisAider',
  'Share': 'شارك',
  'Search by name or description': 'ابحث مستخدما اسمها او وصفها',
  'Supportive Establishments': 'المؤسسات الداعمة',
  'Please confirm your email now to access your account!': 'يرجى إكمال التأكيد في بريدك الإلكتروني الآن للدخول إلى حسابك',
  'Date': 'التاريخ',
  'Amount': 'الكمية',
  'Charity': 'الجمعية الخيرية',
  'Social Login': 'الدخول مغ مواقع التواصل',
  'Logout from facebook': 'الخروج من فيسبوك',
  'Login with facebook': 'الدخول مع فيسبوك',
  'Login with your Social Account': 'الدخول مغ مواقع التواصل',
  'Add Supportive Establishment': 'إضافة مؤسسة داعمة جديدة',
  'Are you sure to logout and register new establishment?': 'هل أنت متأكد من الخروج وتسجيل مؤسسة جديدة؟',
  'Cancel': 'إلغاء',
  'Admin': '',
  'Admin Dashboard': '',
  'Dashboard': '',
  'All': '',
  'Add': '',
  'Update': '',
  'All Associations': '',
  'Add New Association': '',
  'Update Associations.': '',
  'Association name': '',
  'description': '',
  'Logo URL': '',
  'Twitter Username': '',
  'IBAN': '',
  'BIC': '',
  'Association registration failed, please try again': '',
  'Association registration successful': '',
  'Register': ''
}

export default localizations



//////////////////
// WEBPACK FOOTER
// ./translations/locales/ar.js
// module id = 100
// module chunks = 1